import { render, staticRenderFns } from "./MenuProduct.vue?vue&type=template&id=6d25f904&scoped=true&"
import script from "./MenuProduct.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuProduct.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuProduct.vue?vue&type=style&index=0&id=6d25f904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25f904",
  null
  
)

export default component.exports